module.exports = __webpack_public_path__ + "static/img/mycelia_64.834cfdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mycelia_64.png
// module id = uinH
// module chunks = 0